module.exports = __webpack_public_path__ + "img/P_FAQ03.1546c1b8.png";